import { Injectable } from '@angular/core';
import * as objectHash from 'object-hash';

@Injectable()
export class ObjectHash {
  readonly OBJECT_HASH_OPTS = {
    algorithm: 'sha1',
    respectType: false,
  };

  createHash(obj) {
    // we wrap this function to make it easier to test (CM).
    return objectHash(obj, this.OBJECT_HASH_OPTS);
  }
}
